import NullStorage from './NullStorage'

export default function getSafeStorage(type: 'session' | 'local' = 'session'): Object {
  const storage = getStorage(type)
  return {
    setItem(k: string, v: {}) {
      try {
        storage.setItem(k, JSON.stringify(v))
      } catch (e) {
        // Nothing
      }
    },
    getItem(k: string, defaultValue: any = {}) {
      try {
        return parseSafely(storage.getItem(k) || 'null', defaultValue)
      } catch (e) {
        return defaultValue
      }
    },
    clear() {
      try {
        storage.clear()
      } catch (e) {
        // Nothing
      }
    },
    removeItem(k: string) {
      try {
        storage.removeItem(k)
      } catch (e) {
        // Nothing
      }
    },
  }
}

export function getStorage(type: 'session' | 'local') {
  try {
    switch (type) {
      case 'session':
        return window.sessionStorage || new NullStorage()
      case 'local':
        return window.localStorage || new NullStorage()
      default:
        throw new Error(`Unknown storage type ${type}`)
    }
  } catch (err) {
    return new NullStorage()
  }
}

function parseSafely(serialized: string, defaultValue: any = {}): any {
  try {
    return JSON.parse(serialized) || defaultValue
  } catch (e) {
    return defaultValue
  }
}
